import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Auth } from '@aws-amplify/auth'
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Card from '@material-ui/core/Card';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';

import LogoBasic from './basicLogo.svg';

import './styles.scss';


const CustomAuth = (props) => {
  const initialFormState = {
    username: '',
    password: '',
    email: '',
    authCode: '',
    formType: 'signedIn',
    newPassword: ''
  }
  const [formState, setFormState] = useState(initialFormState);
  const [errorMessage, setErrorMessage] = useState('');

  const onChange = (e) => {
    e.persist();
    setFormState({
      ...formState,
      [e.target.name]: e.target.value
    });
  }

  const { formType } = formState;

  const signUp = async () => {
    const { username, email, password } = formState;
    await Auth.signUp({ username, password, attributes: { email } })
      .then(res => {
        console.log("Successful sign up");
        setErrorMessage('');
        setFormState({ ...formState, formType: 'confirmSignUp' });
      })
      .catch(err => {
        console.log("ERROR signing up >>>", err);
        setErrorMessage(err.message);
      });
  }

  const confirmSignUp = async () => {
    const { username, authCode } = formState;
    await Auth.confirmSignUp(username, authCode)
      .then(res => {
        console.log("Successful sign up confirmation");
        setErrorMessage('');
        setFormState({ ...formState, formType: 'signIn' });
      })
      .catch(err => {
        console.log("ERROR confirming sign up >>>", err);
        setErrorMessage(err.message);
      });
  }

  const signIn = async () => {
    const { username, password } = formState;
    await Auth.signIn(username, password)
      .then(res => {
        console.log("Successful sign in", res);
        setErrorMessage('');
        if (res.challengeName === 'NEW_PASSWORD_REQUIRED') {
          setFormState({ ...formState, formType: 'requireNewPassword' });
        } else {
          setFormState({ ...formState, formType: 'signedIn' });
        }
      })
      .catch(err => {
        console.log("ERROR signing in >>>", err);
        setErrorMessage(err.message);
      });
  }

  const sendCode = async () => {
    const { username } = formState;
    await Auth.forgotPassword(username)
      .then(res => {
        console.log("Sent code");
        setErrorMessage('');
        setFormState({ ...formState, formType: 'resetPassword' });
      })
      .catch(err => {
        console.log("ERROR sending code >>>", err);
        setErrorMessage(err.message);
      })
  }

  const resetPassword = async () => {
    const { username, authCode, password } = formState;
    await Auth.forgotPasswordSubmit(username, authCode, password)
      .then(res => {
        console.log("Successfully reset password");
        setErrorMessage('');
        setFormState({ ...formState, formType: 'signIn' });
      })
      .catch(err => {
        console.log("ERROR resetting password >>>", err);
        setErrorMessage(err.message);
      })
  }

  const requireNewPassword = async () => {
    const { username, password, newPassword } = formState;
    await Auth.signIn(username, password)
      .then(async (res) => {
        console.log("requireNewPassword: Attempting sign in");
        setErrorMessage('');
        if (res.challengeName === 'NEW_PASSWORD_REQUIRED') {
          const loggedUser = await Auth.completeNewPassword(res, newPassword);
          console.log('requireNewPassword: Successfully signed in.');
          setFormState({ ...formState, formType: 'requireNewPassword' });
        } else {
          console.log('requireNewPassword: New Password NOT Required. Successfully signed in.');
        }
      })
      .catch(err => {
        console.log("ERROR at requireNewPassword >>>", err);
        setErrorMessage(err.message);
      });
  }

  useEffect(() => {
    Auth.currentUserInfo()
    .then(res => {
      if (res !== null) {
        setFormState({...formState, formType: 'signedIn'});
      } else {
        setFormState({...formState, formType: 'signIn'});
      }
    })
    .catch(err => {
      console.error(err);
    })
  }, [])

  if (formType !== 'signedIn') {
    return (
      <Container fluid className="login-container" style={{ position: 'relative', overflow: 'hidden' }}>
        {/* <Design /> */}

        <Row className="align-items-center" style={{height: '100vh'}}>
          {/* <Col id="welcome-row" md={5} >

          </Col> */}
          <Col md={6} lg={4} xs={10} sm={8} className="pt-4">
            <img id="login-logo-sm" src={LogoBasic}></img>
            {/* <Logo /> */}
            {/* <img src={Logo} /> */}
            <p id="upstream">upstream </p>
            <p className="text-danger error-message">{errorMessage}</p>

            {formType === 'signIn' && (
            <Card className="dashboard-card">
              <div className="text-center">
                <div className="auth-container">
                  <FormControl margin="normal" required fullWidth>
                    <TextField onChange={onChange} className="brand-input-styles" variant="outlined" id="username" name="username" autoComplete="email" key="username" label="Username" autoFocus />
                  </FormControl>
                  <FormControl margin="normal" required fullWidth>
                    <TextField onChange={onChange} className="brand-input-styles" variant="outlined" type="password" id="password" name="password" autoComplete="current-password" key="password" label="Password" />
                  </FormControl>
                </div>

                <div>
                  <Button id="create-button" onClick={signIn}>Log In</Button>
                </div>
                <div>
                  <Button
                    id="forgot-button"
                    onClick={() => setFormState({ ...formState, formType: 'forgotPassword' })}
                  >
                    forgot your password?
                  </Button>
                </div>
                <div>
                  <Button
                    id="small-button"
                    onClick={() => setFormState({ ...formState, formType: 'resetPassword' })}
                  >
                    Have a code?
                  </Button>
                </div>

                {/* THIS IS THE CREATE ACCOUNT BUTTON
                 it's my understanding that it's needed right now so I've removed it */}

                {/* <Button
                  id="create-button"
                  variant="contained"
                  onClick={() => setFormState({ ...formState, formType: 'signUp' })}
                >
                  Create an account
                  </Button> */}

              </div>
            </Card>
            )}
            {formType === 'signUp' && (
              <div>
                <FormControl margin="normal" required fullWidth>
                  <TextField onChange={onChange} className="brand-input-styles" variant="outlined" id="username" name="username" autoComplete="email" key="username" placeholder="Username" autoFocus />
                </FormControl>
                <FormControl margin="normal" required fullWidth>
                  <TextField onChange={onChange} className="brand-input-styles" variant="outlined" type="password" id="password" name="password" autoComplete="current-password" key="password" placeholder="Password" autoFocus />
                </FormControl>
                <FormControl margin="normal" required fullWidth>
                  <TextField onChange={onChange} className="brand-input-styles" variant="outlined" id="email" name="email" autoComplete="email" key="email" placeholder="email" autoFocus />
                </FormControl>
                <Button
                  onClick={signUp}
                  variant="primary"
                  block
                >
                  Sign Up
                </Button>
                <Button
                  variant="primary"
                  block
                  onClick={() => setFormState({ ...formState, formType: 'confirmSignUp' })}
                >
                  Confirm a code
                </Button>
                <Button
                  variant="primary"
                  block
                  onClick={() => setFormState({ ...formState, formType: 'signIn' })}
                >
                  Back to Sign In
                </Button>
              </div>
            )}
            {formType === 'confirmSignUp' && (
              <div>
                <FormControl margin="normal" required fullWidth>
                  <InputLabel htmlFor="username">Username</InputLabel>
                  <Input onChange={onChange} id="username" name="username" autoComplete="email" key="username" placeholder="Username" autoFocus />
                </FormControl>
                <FormControl margin="normal" required fullWidth>
                  <InputLabel htmlFor="authCode">Confirmation Code</InputLabel>
                  <Input onChange={onChange} id="authCode" name="authCode" key="authCode" placeholder="Confirmation Code" autoFocus />
                </FormControl>
                <div className="auth-btn" />
                <Button
                  block
                  variant="primary"
                  onClick={confirmSignUp}

                >
                  Confirm
                </Button>
                <Button
                  block
                  variant="primary"
                  onClick={() => setFormState({ ...formState, formType: 'signIn' })}
                >
                  Back to Sign In
                </Button>
              </div>
            )}
            {formType === 'forgotPassword' && (
              <Card className="dashboard-card">
                <div className="auth-container text-center">
                  <FormControl margin="normal" required fullWidth>
                    <TextField onChange={onChange} className="brand-input-styles" variant="outlined" id="username" name="username" autoComplete="email" key="username" label="Username" autoFocus />
                  </FormControl>

                  <div>
                    <Button id="code-button" onClick={sendCode}>Send Code</Button>
                  </div>
                  <div>
                    <Button id="back-button" onClick={() => setFormState({ ...formState, formType: 'signIn' })}>Back to Sign In</Button>
                  </div>
                </div>
              </Card>
            )}
            {formType === 'resetPassword' && (
              <Card className="dashboard-card">
                <div className="auth-container text-center">
                  <FormControl margin="normal" required fullWidth>
                    <TextField onChange={onChange} className="brand-input-styles" variant="outlined" id="username" name="username" autoComplete="email" key="username" label="Username" autoFocus />
                  </FormControl>
                  <FormControl margin="normal" required fullWidth>
                    <TextField onChange={onChange} className="brand-input-styles" variant="outlined" id="authCode" name="authCode" key="authCode" label="Code" autoFocus />
                  </FormControl>
                  <FormControl margin="normal" required fullWidth>
                    <TextField onChange={onChange} className="brand-input-styles" variant="outlined" type="password" id="password" name="password" key="password" label="New Password" placeholder="New Password" autoFocus />
                  </FormControl>
                  <div>
                    <Button id="reset-button" onClick={resetPassword}>Reset Password</Button>
                  </div>
                  <div>
                    <Button id="back-button" onClick={() => setFormState({ ...formState, formType: 'signIn' })}>Back to Sign In</Button>
                  </div>
                </div>
              </Card>
            )}
            {formType === 'requireNewPassword' && (
              <Card className="dashboard-card">
                <div className="auth-container text-center">
                  {!formState.username && (
                    <FormControl margin="normal" required fullWidth>
                      <TextField onChange={onChange} className="brand-input-styles" variant="outlined" id="username" name="username" autoComplete="email" key="username" label="Username" autoFocus />
                    </FormControl>
                  )}
                  {!formState.password && (
                    <FormControl margin="normal" required fullWidth>
                      <TextField onChange={onChange} className="brand-input-styles" variant="outlined" type="password" id="password" name="password" key="password" label="Password" />
                    </FormControl>
                  )}
                  <FormControl margin="normal" required fullWidth>
                    <TextField onChange={onChange} className="brand-input-styles" variant="outlined" type="password" id="newPassword" name="newPassword" key="newPassword" label="New Password" />
                  </FormControl>
                  <div>
                    <Button id="reset-button" onClick={requireNewPassword}>Change</Button>
                  </div>
                  <div>
                    <Button id="back-button" onClick={() => setFormState({ ...formState, formType: 'signIn' })}>Back to Sign In</Button>
                  </div>
                </div>
              </Card>
            )}
          </Col>
          {/* <Col md={1} > </Col> */}
        </Row>
      </Container>
    )
  } else {
    return <div style={{ paddingTop: 80 }} />
  }
}

export default CustomAuth;